import { combineReducers } from 'redux';
import userReducer from './Users/reducer';
import driverReducer from './Drivers/reducer';
import authReducer from './Auth/reducer';
import emailReducer from './Email/reducer';
import productsReducer from './Products/reducer';
import searchReducer from './Search/reducer';
import tripsReducer from './Trips/reducer';
import tagsReducer from './Tags/reducer';
import locationsReducer from './Locations/reducer';
import environmentReducer from './Environment/reducer';
import fleetReducer from './Fleet/reducer';
import notificationsReducer from './Notifications/reducer';

export default combineReducers({
  users: userReducer,
  drivers: driverReducer,
  auth: authReducer,
  email: emailReducer,
  products: productsReducer,
  search: searchReducer,
  trips: tripsReducer,
  tags: tagsReducer,
  locations: locationsReducer,
  environment: environmentReducer,
  fleet: fleetReducer,
  notifications: notificationsReducer,
});
